import * as React from 'react';
import {  useContext } from "react";
import { styled, useTheme } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import List from '@mui/material/List';
import IconButton from '@mui/material/IconButton';
import { SidebarMenu } from './SidebarMenu';
import {Context} from "../../../_context/Store";

const drawerWidth = 300;

const openedMixin = (theme) => ({
	width: drawerWidth,
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.enteringScreen,
	}),
	overflowX: 'hidden',
});

const closedMixin = (theme) => ({
	transition: theme.transitions.create('width', {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	}),
	overflowX: 'hidden',
	width: `calc(${theme.spacing(7)} + 1px)`,
	[theme.breakpoints.up('sm')]: {
		width: `calc(${theme.spacing(8)} + 1px)`,
	},
});

const DrawerHeader = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-end',
	padding: theme.spacing(0),
	// necessary for content to be below app bar
	...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
	shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
	width: drawerWidth,
	flexShrink: 0,
	whiteSpace: 'nowrap',
	boxSizing: 'border-box',
	...(open && {
		...openedMixin(theme),
		'& .MuiDrawer-paper': openedMixin(theme),
	}),
	...(!open && {
		...closedMixin(theme),
		'& .MuiDrawer-paper': closedMixin(theme),
	}),
}));



export default function MobileSidebar(props) {
	const theme = useTheme();
    const [state, dispatch] = useContext(Context);

	return (
		<>
			<Drawer variant="permanent" 
				open={props.open} className={props.open ? 'sbt-dashboard-drawer-mobile':'sbt-dashboard-drawer-open'}>
				<DrawerHeader>
					<IconButton
						onClick={props.iconHandleClick}
						sx={{
							display: 'flex',
							width: '40px',
    						height: '40px',
							justifyContent:'center',
							mt:'5px',
							ml:'5px',
							justifyContent: open ? 'flex-start' : 'flex-end',
							marginRight: open ? 'auto' : '5px',
						}}
					>
						<span className="sba-drawer-toggle-ic1n">
							{props.open ? <CloseIcon /> : ''}
						</span>
					</IconButton>
				</DrawerHeader>
				<List className="sbt-dashboard-sidebar">
					<SidebarMenu open={props.open} />
				</List>
			</Drawer>
		</>
	);
}
